import * as yup from 'yup';

export const prizeSchema = yup.object().shape({
  code: yup.string().required('El código es requerido'),
  name: yup.string().required('El nombre es requerido'),
  description: yup.string().nullable(),
});

































